module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "لماذا-أرتدي-الاسود"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "why-im-wearing-black"
    }
  }, [_c('p', [_vm._v("I don’t wear black because I’m holding a funeral or I’m in mourning")]), _vm._v(" "), _c('p', [_vm._v("but because I want to accept this life positively and well, black, sorb everything is not beautiful and turn it back to something prettiest.")]), _vm._v(" "), _c('p', [_vm._v("It gives me happiness as the oxygen gives the life, gives me hope as the sunrise did. So, sadness doesn’t link with black at all, even if at funerals it just relieves the sadness that the person feels when someone dear left.")]), _c('br'), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd89e44e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0004.vue
// module id = 87
// module chunks = 0